module.exports = __webpack_public_path__ + "static/media/gilt.86006e19.jpeg";